<script>
export default {
  name: "IndexBlock"
}
</script>

<template>
  <section class="index-top-form">
    <div class="container">
      <h1 class="index-top-form__title">
        Установка памятников и сопутствующие услуги в
        <span>Минске</span>
      </h1>
      <h2 class="index-top-form__subtitle">От опытных сотрудников</h2>
    </div>
  </section>

</template>

<style scoped lang="scss">
@import "@/assets/scss/home/indexBlock";
</style>